export default __webpack_public_path__ + "static/media/tweet_mid.eae5ca21.png";